import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import kebabCase from 'lodash/kebabCase'
import { H2 } from 'components/common/Text/Text'
import Table from 'components/common/Table/Table'

const BOTTireLineSpecification = ({
  tireSpecifications = [],
  filteredSpecs
}) =>
  <React.Fragment>
    <Title data-at-heading="specifications" headline size="20">Specifications</Title>
    <Table.Wrapper>
      <Table.Table>
        <thead>
          <Table.Row header nowrap>
            { filteredSpecs.map(spec => <Table.Header data-at-table-heading={ kebabCase(spec) } key={ spec } scope="col" cell>{ spec }</Table.Header>) }
          </Table.Row>
        </thead>
        <tbody>
          {
            tireSpecifications.map(({ cells }, index) =>
              <Table.Row key={ index } nowrap zebra>
                { filteredSpecs.map(spec => <Table.Cell key={ spec }>{ cells[spec] }</Table.Cell>)}
              </Table.Row>
            )
          }
        </tbody>
      </Table.Table>
    </Table.Wrapper>
  </React.Fragment>


BOTTireLineSpecification.propTypes = {
  filteredSpecs: PropTypes.arrayOf(PropTypes.string),
  tireSpecifications: PropTypes.arrayOf(PropTypes.shape())
}


export default BOTTireLineSpecification

const Title = styled(H2)`
  margin: 35px 0 25px;
`
